import styled from 'styled-components'

export const Container = styled.section`
	& > .breadcrumb {
		display: flex;
		align-items: center;
		position: relative;
	}
`
